import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/")({
    loader: async ({context}) => {
        const {
            intellsysBaseUrl,
            workspace,
            authenticationStatus: {accessToken},
        } = context;

        return {
            accessToken: accessToken,
            intellsysBaseUrl: intellsysBaseUrl,
            workspaceId: workspace.id,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
